import AxiosInstance from "../Utils/axios/axiosConfig";

export const getGenericStockMatchingData = async (params) => {
  let response = await AxiosInstance.get(
    `inventory/stock-matching/generic-criteria/`,
  );
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

export const updateGenericStockMatchingData = async (data) => {
  let response = await AxiosInstance.post(
    `inventory/stock-matching/generic-criteria/`,
    data
  );    
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

export const getstockMatchingTableData = async (params) => {
  let response = await AxiosInstance.get(
    `inventory/stock-matching/groups/`,
  );
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

export const addStockMatchingGroup = async (body) => {
  let response = await AxiosInstance.post("inventory/stock-matching/groups/",body);
  if(!response.data.error)
  {
    return response.data.data;
  }
  else{
    Promise.reject(response);
  }
}

export const editStockMatchingGroup = async (id,body) => {
  let response = await AxiosInstance.put(`inventory/stock-matching/groups/?id=${id}`,body);
  if(!response.data.error)
  {
    return response.data.data;
  }
  else{
    Promise.reject(response);
  }
}

export const deleteStockMatchinggroup = async (id) => {
  let response = await AxiosInstance.delete(`inventory/stock-matching/groups/?id=${id}`);
  if(!response.data.error)
  {
    return response.data.data;
  }
  else
  {
    Promise.reject(response);
  }
}